export enum UserRole {
  ROLE_ADMIN = "ROLE_ADMIN",
  ROLE_USER = "ROLE_USER",
  ROLE_VIEW_ONLY_USER = "ROLE_VIEW_ONLY_USER",
  ROLE_SOLAR_DASHBOARD_ADMIN = "ROLE_SOLAR_DASHBOARD_ADMIN",
  ROLE_METER_READER_USER = "ROLE_METER_READER_USER",
  ROLE_MODBUS_DEVICE_USER = "ROLE_MODBUS_DEVICE_USER",
}
